/* @flow weak */

'use strict';

const React = require('react');
const ControlMixin = require('../../mixins/ControlMixin.jsx');
const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';

const _ = require('lodash');

const DropdownImageGrid = React.createClass({
  mixins: [ControlMixin],

  getInitialState() {
    return {
      menuOpen: false
    };
  },

  toggleMenu() {
    this.setState({ menuOpen: !this.state.menuOpen });
  },

  handleClick(e) {
    this.handleChange(e);
    this.toggleMenu();
  },

  generateOptions() {
    return _.map(this.props.parts, part => {
      let inputID = `uc-c-${this.props.question.id}-${part.id}`;
      let activeClass = this.state.answer === part.id ? ' uc-active uc-checkmark' : '';
      let classremoveHyphen = _.get(part, 'metadata.RemoveHyphen') ? ' uc-part-without-hyphen' : '';
      const hidePartNameClass = this.isPartNamesHidden(this.props.question) ? ' uc-hide-part-name' : '';

      const partDetails = this.getPartDetails(part);

      return (
        <label
          className={'uc-image-select-label' + activeClass}
          key={part.id}
          role='radio'
          htmlFor={inputID}>
          <input
            id={inputID}
            className='uc-c uc-image-select-input'
            type='radio'
            name={this.props.question.name}
            onChange={this.handleClick}
            checked={this.state.answer === part.id}
            value={part.id}
            tabIndex={this.props.tabIndex}
            disabled={this.state.locked} />

          <div className='dot' style={{ backgroundColor: _.get(part, 'metadata.ColorHex') }}></div>
          <div className={'uc-part-name' + classremoveHyphen + hidePartNameClass}>
            <p>{this.displayPartTitle(part)}</p>
            <p>{this.displayPartName(part)}</p>
            <p>{this.displayPrice(part)}</p>
          </div>
          {partDetails ?
            <p className="uc-part-details" dangerouslySetInnerHTML={{ __html: partDetails }}></p>
            : null}
        </label>
      );
    });
  },

  render() {
    let title = _.get(this.props.question, 'metadata.control.Choose.FirstOptionCustomText') || Config.features.chooseDropdownText[ln] || Config.features.chooseDropdownText['en_US'];
    if (this.state.answer) {
      let part = _.find(this.props.parts, { id: this.state.answer });
      title = this.displayPartName(part);
    }

    return (
      <div className='uc-control uc-c-dropdown-image-grid'>
        <div className='uc-c-dropdown-image-grid-header' onClick={this.toggleMenu}>{title}</div>
        <div className='uc-c-dropdown-image-grid-options' style={{ display: this.state.menuOpen ? 'block' : 'none' }}>
          {this.generateOptions()}
        </div>
      </div>
    );
  }
});

module.exports = DropdownImageGrid;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/DropdownImageGrid.jsx